import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ReportingDataService } from '../shared/services/reporting-data.service';
import { ReportingUtilizationComponent } from './reporting-utilization.component';

@Component({
  selector: 'app-reporting-adoption',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ReportingUtilizationComponent
  ],
  templateUrl: './reporting-adoption.component.html',
  styleUrl: './reporting-adoption.component.scss'
})
export class ReportingAdoptionComponent {

  activeProgramPage: 'adoptionOverview' | 'utilizationOverview' | 'trainingCompletion' = 'adoptionOverview';

  get kpiCards() { return this.dataService.adoptionKpis; }
  get adoptionNamcRows() { return this.dataService.adoptionNamcRows; }
  get trendConfig() { return this.dataService.adoptionTrendConfig; }
  readonly pageFilters = ['Latest Export', 'All NAMCs', 'All Shops'];

  selectedPlant = 'ALL';
  selectedShopType = 'ALL';

  get filteredAdoptionRows() {
    return this.selectedPlant === 'ALL'
      ? this.adoptionNamcRows
      : this.adoptionNamcRows.filter(r => r.namc === this.selectedPlant);
  }

  selectProgramPage(page: 'adoptionOverview' | 'utilizationOverview' | 'trainingCompletion'): void {
    this.activeProgramPage = page;
  }

  trackByNamc(_: number, row: { namc: string }): string { return row.namc; }
  trackByShop(_: number, shop: { name: string }): string { return shop.name; }
  trackByIndex(index: number): number { return index; }

  constructor(private readonly dataService: ReportingDataService) {}
}
